import { useNavigate } from "react-router-dom";
import { useFeedbackAlerts } from "../../_app/hooks";
import { deleteLogicMonitorToken } from "../../logic-monitor/api";
import { SingleActionCard } from "../../_app/components/SingleActionCard";
import { Group } from "../../account/types";
import { createStylesheet } from "../../_app/utils/styles";
import { UIGrid, UITypography } from "../../_app/components";
import { useContextProvider } from "../providers/ContextProvider";

interface GroupCardProps {
  group: Group;
  lg: any;
}

const GroupCard = ({ group, lg, ...rest }: GroupCardProps) => {
  const { setFeedbackAlertSuccess } = useFeedbackAlerts();
  const { setSelectedGroupId } = useContextProvider();
  const classes = useStyles();
  const navigate = useNavigate();

  const handleSelectGroup = async () => {
    setFeedbackAlertSuccess("Selection successful");
    setSelectedGroupId(group.id);
    deleteLogicMonitorToken();
    navigate("/");
  };

  // If it's dummy group name, use the first user accessible account name instead
  const displayName = group?.name?.startsWith("GRP-") ? group?.userAccessibleAccounts?.[0]?.name || group?.name : group?.name;

  return (
    <UIGrid size={{ sm: 12, md: 6, lg: lg }} className={classes.cardWrap} {...rest}>
      <SingleActionCard
        height="120px"
        actionTitle="Select"
        actionFunction={handleSelectGroup}
        actionTestId="select-group-button"
        elevation={2}
      >
        <div className={classes.cardContent}>
          <UITypography variant="h4">{displayName}</UITypography>
        </div>
      </SingleActionCard>
    </UIGrid>
  );
};

const useStyles = createStylesheet(() => ({
  cardWrap: {
    maxWidth: "356px",
  },
  cardContent: {
    margin: "auto",
    textAlign: "center",
  },
}));

export default GroupCard;
